import { useBusinessSettingsContext } from '../../hooks/useBusinessSettingsContext'
import ProductForm from './ProductForm'
import ProductFormFashion from './ProductFormFashion'

function ProductFormRouter() {
  const { activeProfile } = useBusinessSettingsContext()

  if (activeProfile?.rubro === 'indumentaria' && (activeProfile?.subrubro || 'femenina') === 'femenina') {
    return <ProductFormFashion />
  }

  return <ProductForm />
}

export default ProductFormRouter
